import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'app-editable-cell-renderer',
	template: `
		<div class="editable-cell-wrapper" [title]="'common_editable_cell_title_click_to_edit' | translate">
			<span class="cell-content">{{ value }}</span>
			<span class="edit-icon">✎</span>
		</div>
	`,
	styles: [
		`
			.editable-cell-wrapper {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				height: 100%;
				padding: 0 8px;
				border-left: 3px solid #7367f0;
				box-sizing: border-box;
				cursor: pointer;
				transition: background-color 0.15s ease;
			}

			.editable-cell-wrapper:hover {
				background-color: rgba(115, 103, 240, 0.06);
			}

			.cell-content {
				flex: 1;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 0.5rem;
				height: 2.5rem;
			}

			.edit-icon {
				color: #3f51b5;
				font-weight: bold;
				margin-left: 8px;
				opacity: 0.5;
				transition: opacity 0.2s ease;
				font-size: 14px;
				flex-shrink: 0;
			}

			.editable-cell-wrapper:hover .edit-icon {
				opacity: 1;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class EditableCellRendererComponent implements ICellRendererAngularComp {
	value: any;

	agInit(params: ICellRendererParams): void {
		this.value = params.valueFormatted || params.value;
	}

	refresh(params: ICellRendererParams): boolean {
		this.value = params.valueFormatted || params.value;
		return true;
	}
}
